module.exports = __webpack_public_path__ + "static/media/ball_2_7.96a6836e.mp3";